module.exports = __webpack_public_path__ + "img/25.0417eb37.png";